import React from 'react';
import MainLayout from './components/layouts/MainLayout';
import { ToastContainer, Flip } from 'react-toastify';
import './assets/css/react-toastify.css';
import './assets/css/react-modal.css';
import 'antd/dist/antd.css';
import './custom.css';

class Layout extends React.Component {
	render() {
		return (
			<React.Fragment>
				<ToastContainer autoClose={false}
					hideProgressBar
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnVisibilityChange={false}
					draggable
					pauseOnHover={false}
					transition={Flip}
					position="top-right" />
				<MainLayout />
			</React.Fragment>
		)
	}
}
export default Layout;